import { Option, Orientation } from "./state/types.ts";
import React, { useEffect, useRef } from 'react';


export function sort_by_southlike(a : {azimuth_deg: number}, b : {azimuth_deg: number}) : 1 | 0 | -1{
  const deg_a = Math.abs(a.azimuth_deg - 180);
  const deg_b = Math.abs(b.azimuth_deg - 180);
  if ( deg_a > deg_b ) return 1;
  if ( deg_a < deg_b ) return -1;
  return 0;
}

export function azimuth_deg_to_roof_orientation(deg : number) : Orientation | undefined{ 
  if( deg < 15 || deg >= 345){
    return "N"
  }
  if(deg >= 15 && deg < 75){
    return "NO"
  }
  if(deg >= 75 && deg < 105){
    return "O"
  }
  if(deg >= 105 && deg < 165){
    return "SO"
  }
  if(deg >= 165 && deg < 195){
    return "S"
  }
  if(deg >= 195 && deg < 255){
    return "SW"
  }
  if(deg >= 255 && deg < 285){
    return "W"
  }
  if(deg >= 285 && deg < 345){
    return "NW"
  }
  return undefined
}

export function clsx(...args: Array<string | undefined | false>) : string{
    return args.filter(s => (s !== undefined) && (s !== false)).join(' ');
}

export function  slugify(label: string) : string{
  return label
  .toLocaleLowerCase()
  .replaceAll('ä', 'ae')
  .replaceAll('ö', 'oe')
  .replaceAll('ü', 'ue')
  .replaceAll('Ä', 'Ae')
  .replaceAll('Ö', 'Oe')
  .replaceAll('Ü', 'Ue')
  .replaceAll('ß', 'ss')
  .replaceAll(' ', '-')
  .replaceAll('_', '-')
  .replaceAll(',', '')
  .replaceAll('.', '')
}


export function inverse_key_value(options: Array<Option>){
  return options.reduce((acc: Record<string,string>, o: Option)=>{
    acc[o.value] = o.label;
    return acc;
  },{});
}

export function round_to_10(x : number){
  return Math.round(x);
  // const y = Math.round(x / 10) * 10;
  // if(Number.isNaN(y)){
  //   return 0;
  // }else{
  //   return y;
  // }
}

export function round_to_01(x : number){
  const y = Math.round(x * 10) / 10;
  if(Number.isNaN(y)){
    return 0;
  }else{
    return y;
  }
}

export function round_to_1000(x : number){
  const y = Math.round(x / 1000) * 1000;
  if(Number.isNaN(y)){
    return 0;
  }else{
    return y;
  }
}

export function format_1000(x : number) : string{
  return x.toLocaleString('de');
}

const useDidMountEffect = (first, other, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
          other();
        }else {
          didMount.current = true;
          first();
        }
    }, deps);
}

export default useDidMountEffect;

export function inputOnKeyUp(event: React.KeyboardEvent , closure: () => void){
  if(event.code != "Enter" && event.code != " "){return;}
  closure();
}